import { render } from "./EmployeeTab.vue?vue&type=template&id=5add569a&scoped=true"
import script from "./EmployeeTab.vue?vue&type=script&lang=js"
export * from "./EmployeeTab.vue?vue&type=script&lang=js"

import "./EmployeeTab.vue?vue&type=style&index=0&id=5add569a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5add569a"]])

export default __exports__